import * as React from 'react'
import io from 'socket.io-client';
import config from '../constants/config';

class SocketClient {
  socket = null
  isConnected = false
  urlHost = ""
  plat_form = ""
  path = ""
  token = null
  reconnection = false
  constructor(args = {}) {
    this.setupConfig(args)
  }
  setupConfig(args = {}) {
    const defaultProps = {
      reconnection: true,
    };
    console.log("SocketClient->setupConfig->args", args)
    Object.assign(this, defaultProps, args);
  }

  init(path: string = "", token: string, forceNew: boolean = true) {
    this.start(path, token, forceNew)
  }

  start(path: string = "", token: string, forceNew: boolean = true) {
    if (!this.isConnected) {
      this.urlHost = path !== "" ? `${config.server_socket}/${path}` : config.server_socket
      this.path = path;
      this.token = token
      let query = "token=" + token
      let options = {
        forceNew: forceNew,
        jsonp: false,
        query: query
      }
      this.socket = io(this.urlHost, options);
      this.initListeners()
    }
  }

  initListeners() {
    // Set isConnected = true when socket successfully connects
    this.socket.on('connect', () => {
      console.log("SocketClient->connected")
      this.isConnected = true;
    });

    this.socket.on('connect_error', (err) => {
      console.log("connect_error_socket", err)
      this.isConnected = false;
    });

    this.socket.on('reconnect', (err) => {
      console.log("reconnect", err)
    });

    this.socket.on("disconnected", (args) => {
      this.isConnected = false;
      console.log("disconnected", args)
    });

    this.socket.on("disconnect", (res) => {
      console.log("disconnect", res)
      this.isConnected = false;
    });
  }

  removeAllListeners() {
    if (this.socket) {
      this.socket.off()
    }
  }

  removeListener(event, callback = null) {
    if (this.socket) {
      this.socket.off(event, callback)
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, (args) => {
        return callback(args)
      })
    }
  }

  emit(event: string, args: any = null) {
    if (this.socket) {
      this.socket.emit(event, args)
    }
  }

  off(event: string) {
    if (this.socket) {
      this.socket.off(event)
    }
  }

  close() {
    console.log("closeSocketMain")
    if (this.socket) {
      console.log("socket->close", this.socket)
      this.isConnected = false;
      this.socket.emit('forceDisconnect');
      this.socket.disconnect()
      this.socket.close();
      this.socket.removeAllListeners()
      this.socket = null
    }
  }
}

export default SocketClient;
export { SocketClient };
